
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/livestreams/[id]",
      function () {
        return require("private-next-pages/[locale]/livestreams/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/livestreams/[id]"])
      });
    }
  